// ponytail: one pass for every target=_blank (theme + plugins + CMS)
export default function newTabLinks() {
    const hint = (window.laeA11y && window.laeA11y.openInNewTab) || 'open in a new tab'
    const already = /open(s)? in a new tab/i

    document.querySelectorAll('a[target="_blank"]').forEach((a) => {
        const existing = (a.getAttribute('aria-label') || '').trim()
        if (already.test(existing)) return

        let base = existing
        if (!base) {
            base = (a.textContent || '').replace(/\s+/g, ' ').trim()
            base = base.replace(/\(opens? in a new tab\)/gi, '').trim()
        }

        a.setAttribute('aria-label', base ? `${base} (${hint})` : hint)
    })
}
